import React, { useState, useEffect } from "react";

import {
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import clsx from "clsx";
import { insh as inshst } from "../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { insh, sto, wsto } from "../../../Context/InshData";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { getLS } from "../../../utils/useLS";
import useBreakpoint from "../../../utils/useBreakpoint";
import toast from "react-hot-toast";
import { getBase64 } from "../../../services/ImageServices";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { branch } from "recompose";
import AnnualSuscriptionForm from "./AnnualSuscriptionForm";
import AnnualSuscriptionBegin from "./AnnualSuscriptionBegin";
import AnnualSuscriptionAppBar from "./AnnualSuscriptionAppBar";
import { reFormatDate } from "../../../utils/utils";
import { Archive } from "@material-ui/icons";
import { GetItemFromOptions } from "../../../services/global-services";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        // paddingBottom: theme.spacing(3),
        // direction: "rtl",
        borderColor: "#49B3A7",
        minHeight: "100%",
    },
    input: {
        display: "none",
    },
    imageLogo: {
        marginRight: 20,
        marginTop: 5,
        marginBottom: 10,
        textAlign: "center",
    },
    headerTitle: {
        backgroundColor: "#49B3A7",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold",
        marginBottom: "0.5rem"
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#ADD8E6",
        borderColor: "#49B3A7",

    },

}));
function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`
};


export default function AnnualSuscription(props) {

    // const { AutoOptions, locat, isDialog, DialogClose } = props;
    const { AutoOptions } = props;
    const clasess = useStyles();


    const datas = {
        id: null,
        nameA: "",
        nameE: "",
        FieldA: "",
        FieldE: "",
        bsn_no: "",
        licence_no: "",
        Address: "",
        Tel: "",
        Mobile: "",
        Fax: "",
        Email: "",
        website: "",
        Logo: null,
        Exchangeval: "",
        tax: "",
        port: "",
        tax_no: "",
        BillNotes: "", BillNotes1: "",
        BillNotes2: "",
        BillNotes3: "",
        Disc1_header_ar: "",
        Disc2_header_ar: "",
        Disc3_header_ar: "",
        Disc4_header_ar: "",
        Disc1_header_en: "",
        Disc2_header_en: "",
        Disc3_header_en: "",
        Disc4_header_en: "",
        Disc1_footer_ar: "",
        Disc2_footer_ar: "",
        Disc3_footer_ar: "",
        Disc4_footer_ar: "",
        Disc1_footer_en: "",
        Disc2_footer_en: "",
        Disc3_footer_en: "",
        Disc4_footer_en: "",
        MailBox: "",
        tax_ats: "",
        invval_ats: "",
        actv_elec: "",
        CustDisc: "",
        finyear_date1: "",
        finyear_date2: "",
        showimg: "",
        showvat: "",
        showdisc: "",
        showafterdisc: "",
        showtax: "",
        bank1: "",
        acc1: "",
        bank2: "",
        acc2: "",
        bank3: "",
        acc3: "",
        AddressEn: "",
        chkitemquan: "",
        msg: "",
        offer_type: "",
        VAT_Type: "",
        is_tab3: "",
        tab3val: "",
        consume_type: "",
        img: "",
        cnt: "",
        img2: "",
        contract_no: "",
        activity_name: "",
        city: "",
        branchName: "",
        sales_man: "",
        // StartWorkDate:  moment(AutoOptions.Found[0]?.StartWorkDate).format("DD/MM/YYYY"),
        EndWorkDate: "",
        CStartWorkDate: "",
        CEndWorkDate: "",
        firstAlertDate: "",
        SecondAlertDate: "",
        ThirdAlertDate: "",
        StopWorkingDate: "",
        CStopWorkingDate: "",
        is$sys: "",
        is$$dessys: "",
        is$$$dy: "",
        server_name: "",
        point_name: "",
        status_type: "",
        computer_type: "",
        tax_no_build: "",
        tax_name_street: "",
        tax_name_district: "",
        tax_name_city: "",
        tax_name_country: "",
        tax_zip_code: "",
        tax_additional_address_no: "",
        tax_vat_registration_no: "",
        branch: "",
        footer_img: null,
        header_img: null,
        Enable_archiveing_system:0,
        db_name: sto?.db_namee
    }
    const defBranch=GetItemFromOptions(sto.branchi,AutoOptions.Branches);

    const inshValueAuto = {
        branch: defBranch,
    };

    // const [items, setItems] = useState({
    //     ...SearchActivityReports,
    //     tax_group: AutoOptions.tax_groups[0].id, tax: AutoOptions.tax_groups[0].tax, type: autos_curr.currType[0].id, group_id: AutoOptions.Groupst[0].id,
    //     barcode: AutoOptions.other.barcode, id: AutoOptions.other.lastid, unit: AutoOptions.Units[0].id, subUnits: AutoOptions.Untis,
    // });



    const [params, setParams] = useState({
        ...AutoOptions.Found[0],
        branch:sto.branchi,
        db_name: sto?.db_name,
        // StartWorkDate:reFormatDate(AutoOptions.Found[0]?.StartWorkDate)
        StartWorkDate: formatDate(AutoOptions.Found[0]?.StartWorkDate),
        EndWorkDate: formatDate(AutoOptions.Found[0]?.EndWorkDate),
    });


    const [valueAutos, setValueAutos] = useState(inshValueAuto);
    const [multiCodeList, setMultiCodeList] = useState([]);
    const point = useBreakpoint();
    const [styl, setStyl] = useState(inshst.custm);
    const [isSearch, setIsSearch] = useState(false);
    const [deleteHeader, setDeleteHeader] = useState(false);
    const [deleteFooter, setDeleteFooter] = useState(false);



    const clsConts = useStylesContainers();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();

    const clasCAB = useStylesCAB();
    const locSto = getLS("sto", {});
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const [showPic, setShowPic] = useState(false);
    const [or, setOr] = useState(insh.Or);

    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [parm, setParm] = useState(inshParm);

    const timer = React.useRef();
    const [uiElement, setUiElement] = useState({});

    const [transition, setTransition] = React.useState(undefined);


    const [currUnitList, setCurrUnitList] = useState([]);
    const [GroupsSubs, setGroupsSubs] = useState([]);

    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const [prevent, setPrevent] = useState(false);

    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openMulti, setOpenMulti] = useState(false);
    const [passwordScreen, setPasswordScreen] = useState('');

    const [isOpenScreen, setIsOpenScreen] = useState(false);



    const handCloseDw = async () => {
        newToI(1);
        await setOpenPMD(false);
    };
    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenPMD(true);
    };
    /* e PMD */




    // const ust_o = (updatedData) => {
    function usto(olddata) { }

    const [dataList, setDataList] = useState([]);

    const changAutos = (prop, newValue) => {
        setValueAutos({ ...valueAutos, [prop]: newValue })
        setParams({
            ...params,
            branch: newValue.id
        });
        reloadGets(newValue, true);
        setPrevent(false);
    };

    const changTField = (prop) => (e) => {
        if (prop === "password") {
            setPasswordScreen(e.target.value);
        } else {
            setParams({ ...params, [prop]: e.target.value });
        }
    };

    let AutoItem = params?.Enable_archiveing_system == null ? false :  
    params?.Enable_archiveing_system===1?true:false;

    const [allowArchive, setAllowArchive] = useState(AutoItem);

    const onChangeArchive = (prop) => (e) => {
        setAllowArchive(!allowArchive);
        if (e.target.checked===true){
            setParams({ ...params, Enable_archiveing_system: 1 });
        }else{
            setParams({ ...params, Enable_archiveing_system: 0 });
        }
    };



    const handOpenScreen = (event) => {

        if (passwordScreen === "" || passwordScreen == null) {
            alert("please Enter password")
        } else {
            if (passwordScreen==="BestofthebestCloud") {
                setIsOpenScreen(true);
            } else {
                setIsOpenScreen(false);
                alert(t("password-incorrect"));
            }
        }
    };




    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const ButtonWitting = (prop) => {

    };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    let typeImg = "jpeg";

    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop != "save");
        }, timr);
    };


    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const [snack, setSnack] = React.useState(insh.Snack);

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };
    const handCloseMulti = async (state) => {
        // if (state === "cancle") await restPM(state);
        await setOpenMulti(false);
    };
    const [transitionsmu, setTransitionsmu] = React.useState(undefined);
    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }

    const reloadGets = async (branch, fromBranch) => {
        const tb = {
            wait: true,
            GetFoundation: true,
            parms: {
                iempid: sto.empi,
                branch: branch.id,
                db_name: sto?.db_name
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                if (fromBranch == true) {
                    if (res.data.Found[0].branch == branch.id) {
                        setParams({
                            ...res.data.Found[0],
                            db_name: sto?.db_name
                        });
                        setPrevent(false);
                    } else {
                        setParams({
                            ...res.data.Found[0],
                            branch: branch.id,
                            db_name: sto?.db_name
                        });
                        setPrevent(true);
                    }
                } else {
                    setParams({
                        ...res.data.Found[0],
                        branch: branch.id,
                        db_name: sto?.db_name
                    });
                    setPrevent(false);
                }
            })
            .catch((error) => {
                setParams({
                    ...datas,
                });
                setPrevent(false);
            });
    };

    const will = () => {
        let ob = "yes";
        if (params.id == "" || params.id == null) {
            ob = "no";
        } else if (params.nameA == "" || params.nameA == null) {
            ob = "no";
        } else {
            ob = "yes";
        }
        return ob;
    };

    const addToBS = () => {
        let action = will();

        if (action == "yes") {
            ButtonLoading("save");

            console.log("the curre data is ", params);
            prevent
                ? axios
                    .post(uri + "Foundations", params)
                    .then((res) => {
                        if (res.data) {
                            toast.success(t("save-success"));
                            reloadGets(valueAutos.branch, false);

                            ButtonSuccess("save", 500);

                        } else {
                            ButtonWitting("save");
                            reloadGets(valueAutos.branch, false);
                            toast.success(t("save-success"));
                            ButtonSuccess("save", 1000);
                        }
                    })
                    .catch((res) => {
                        toast.error(t("save-failed"));
                        reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                    })
                :
                axios
                    .put(uri + "Foundations", params)
                    .then((res) => {
                        toast.success(t("update-success"));
                        reloadGets(valueAutos.branch, false);
                        ButtonWitting("save");
                        ButtonSuccess("save", 1000);

                    })
                    .catch((res) => {
                        reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                        toast.error(t("update-failed"));
                    });
        } else {
            //  toast.error(" لم يتم عملية التعديل ");
            alert("Please...Complete The data ");
        }
    };

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    // ==== b sd
    const [open, setOpen] = React.useState(false);

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const onChangeData = (propName) => (event) => {
        setParams({ ...params, [propName]: event.target.value });
    };
    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                >
                    {t("maintenance-contract-data")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                {/* <Hidden only={["xs"]}> */}
                <Container maxWidth={true} style={{ paddingTop: "15px" }}
                >
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <div className={clasess.root} style={{ backgroundColor: "fff" }}>
                            {!isOpenScreen ?
                                (
                                    <AnnualSuscriptionBegin
                                        {...{
                                            AutoOptions,
                                            changTField,
                                            params,
                                            valueAutos,
                                            changAutos,
                                            handOpenScreen,
                                            passwordScreen,
                                            setPasswordScreen
                                        }}
                                    />
                                ) :
                                (
                                    <AnnualSuscriptionForm
                                        {...{
                                            AutoOptions,
                                            changTField,
                                            params,
                                            valueAutos,
                                            changAutos,
                                            onChangeData,
                                            onChangeArchive,
                                            allowArchive
                                        }}
                                    />
                                )}

                        </div>

                    </Grid>
                </Container>
                {/* </Hidden> */}



            </Typography>
            {isOpenScreen &&
                (
                    <AnnualSuscriptionAppBar {...{
                        buttonClassnameSave,
                        clasCAB,
                        addToBS,
                        loading,
                        clasBA,
                        backHome,
                        back,
                        prevent
                    }}
                    />
                )}

        </div>
    );
}
